import React, { useState, useEffect, useContext } from 'react';
import {
    useHistory,
    Route,
    Redirect
} from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { EidAuthContext } from '../eid/EIDAuthContext';
import {useSelector} from "react-redux";

const PrivateRoute = ({ render: Component, skipRoleCheck = false, ...rest }) => {
    const aboutMe = useSelector(state => state.user.aboutMe);
    const history = useHistory();
    const [loaded, setLoaded] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const { eidUser } = useContext(EidAuthContext)
    const roles = aboutMe?.user?.role || [];
    const hasValidRole = Array.isArray(roles) && roles.length > 0;
    const authenticate = () => {
        if (eidUser) {
            setLoaded(true);
            setIsAuthenticated(true);
            return;
        }
        Auth.currentAuthenticatedUser()
            .then((user) => {
                setLoaded(true);
                setIsAuthenticated(true);
            })
            .catch(() => history.push('/auth'));
    };

    useEffect(() => {
        authenticate();
        const unlisten = history.listen(async () => {
            if (!eidUser) {
                try {
                    await Auth.currentAuthenticatedUser();
                } catch {
                    if (isAuthenticated) {
                        setIsAuthenticated(false);
                    }
                }
            }
        });

        return () => unlisten();
    }, [isAuthenticated]);

    if (!loaded) return null;

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!isAuthenticated) {
                    return <Redirect to="/auth" />;
                }

                if (!hasValidRole && !skipRoleCheck ) {
                    return <Redirect to="/error" />;
                }

                return <Component {...props} />;
            }}
        />
    );
};

export default PrivateRoute;